// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__34W-7","inner":"Header_inner__3fQwT","scrolled":"Header_scrolled__3rNHN","logo":"Header_logo__3XHlx"};